import { render, staticRenderFns } from "./FieldsControlButtons.vue?vue&type=template&id=969b7230&"
import script from "./FieldsControlButtons.vue?vue&type=script&lang=js&"
export * from "./FieldsControlButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports